import { resourceExplorerDimensionSelector } from "./resourceExplorerDimensionSelector";
import { RootState } from "../../../../store";

export const resourceExplorerDimensionFilterAppliedSelector = (
  state: RootState,
) => {
  return !!resourceExplorerDimensionSelector(state);
};
